import { getDay, getMonthString, getRegularDate, getYear } from '@utils/dates';

const getUpscHeroDateLabel = (date = new Date()) => {
  const day = getDay(date);
  const month = getMonthString(date, 'long');
  const year = getYear(date);

  return `${day} ${month} ${year}`;
};

export const getUpscHubQuizPromoDescription = (date = new Date()) =>
  `${getUpscHeroDateLabel(date)} · Free MCQs`;

export const getUpscHubPdfPromoDescription = (date = new Date()) =>
  `Access All Free PDFS · ${getRegularDate(date, true)}`;

export const getUpscMonthlyPdfMonthYear = (publishAt?: string) => {
  if (!publishAt) {
    return { day: '', month: '', year: '' };
  }

  const date = new Date(
    publishAt.includes('T') ? publishAt : `${publishAt}T00:00:00Z`
  );
  if (Number.isNaN(date.getTime())) {
    return { day: '', month: '', year: '' };
  }

  return {
    day: String(date.getUTCDate()),
    month: date.toLocaleString('en-US', {
      month: 'long',
      timeZone: 'UTC'
    }),
    year: String(date.getUTCFullYear())
  };
};

export const getUpscEditionDateLabel = (createdAt?: string) => {
  if (!createdAt) return '';

  const date = new Date(createdAt);
  if (Number.isNaN(date.getTime())) return '';

  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = date.toLocaleString('en-GB', {
    month: 'short',
    timeZone: 'UTC'
  });
  const year = date.getUTCFullYear();

  return `${day} ${month} ${year}`;
};

export default getUpscHeroDateLabel;
